export const PageDataState = {
    Searchs: {
        eec_nets_id: {
            type: 'text',
            id: 'eec_nets_id',
            label: '',
            value: '',
        },
        network_operation_name: {
            type: 'text',
            id: 'network_operation_name',
            label: 'การดำเนินงาน',
            value: '',
            placeholder: 'การดำเนินงาน',
        },
        network_operation_status: {
            type: 'select',
            id: 'network_operation_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        eec_nets_id: {
            type: 'select',
            id: 'eec_nets_id',
            label: 'ศูนย์เครือข่าย',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },        
        name: {
            type: 'text',
            id: 'name',
            label: 'การดำเนินงานของศูนย์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        description: {
            type: 'textarea',
            rows: '3',
            id: 'description',
            label: 'รายละเอียด',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        }, 
        result: {
            type: 'textarea',
            rows: '5',
            id: 'result',
            label: 'ผลการดำเนินงาน',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: '' }
        },          
        years: {
            type: 'select',
            id: 'years',
            label: 'ปี',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },                 
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }       
    },
    InputGroup: {}
}